module.exports = __webpack_public_path__ + "static/media/timeline-point.5e555164.svg";